import { FieldLabel } from '@calendly/form/parts';
import { I18n } from '@calendly/i18n';
import { NAME_FORMATS } from '@calendly/routing-form-landing';
import { Grid, GridItem } from '@calendly/ui/components/grid';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { InputPreview, RadioPreview } from './inputs';
const inputLabelCss = "ikls457";
const InputLabel = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    label,
    required,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(inputLabelCss, props.className)}>
      <FieldLabel text={label} isRequired={required} />
    </Component>;
});
const nameGridItemCss = "nbvzo1o";
const NameGridItem = forwardRef((props, ref) => <GridItem ref={ref} {...props} className={classNames(nameGridItemCss, props.className)} />);
const InputFieldPreview = ({
  type,
  value,
  placeholder,
  label,
  required
}) => <>
    <InputLabel label={label} required={required} />
    <InputPreview type={type} value={value} placeholder={placeholder} />
  </>;
const RadioGroupFieldPreview = ({
  label,
  required,
  options
}) => <>
    <InputLabel label={label} required={required} />
    {options.map(({
    id,
    name
  }) => <RadioPreview key={id}>{name}</RadioPreview>)}
  </>;
export const Name = ({
  field: {
    label,
    required,
    options
  }
}) => options.nameFormat === NAME_FORMATS.combined ? <InputFieldPreview type="text" label={label} required={required} /> : <Grid>
      <NameGridItem size={6} sizeMobile={12}>
        <InputLabel required={required} label={options.firstNameLabel || label} />
        <InputPreview type="text" />
      </NameGridItem>
      <NameGridItem size={6} sizeMobile={12}>
        <InputLabel required={required} label={options.lastNameLabel} />
        <InputPreview type="text" />
      </NameGridItem>
    </Grid>;
export const Text = ({
  field: {
    label,
    required
  }
}) => <InputFieldPreview type="text" label={label} required={required} />;
export const Email = ({
  field: {
    label,
    required
  }
}) => <InputFieldPreview type="email" label={label} required={required} />;
export const Phone = ({
  field: {
    label,
    required
  }
}) => <InputFieldPreview type="phone" label={label} required={required} />;
export const Textarea = ({
  field: {
    label,
    required
  }
}) => <InputFieldPreview type="textarea" label={label} required={required} />;
export const Select = ({
  field: {
    label,
    required
  }
}) => <InputFieldPreview type="select" label={label} required={required} placeholder={I18n.t('publisher.routing.forms.edit.booking.placeholders.select')} />;
export const Radios = ({
  field: {
    label,
    required,
    options: {
      selectableOptions
    }
  }
}) => <RadioGroupFieldPreview label={label} required={required} options={selectableOptions.map(({
  value
}, index) => ({
  id: index,
  name: value
}))} />;

require("./fields.wyw-in-js.css!=!../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./fields.js");